<div class="sticky-top">
  <app-header-home></app-header-home>
</div>
<div class="body">
  <div class="container-fluid">
    <div id="WrapperContent" class="col-12 col-xl-12">
      <div class="container-fluid">
        <div class="row">
          <div style="width: 5%"></div>
          <div class="col-12 col-xl-8 order-2 order-xl-1">
            <div id="wrapper-articulo" class="styleBotonsBlog mt-5">
              <div class="d-flex flex-column">
                <h3 class="text-center mb-3 title-section py-3 py-xl-0">Artículos</h3>
                @for (fila of listaArticulos; track fila) {
                  <div
                    class="clusterCard d-flex flex-column flex-xl-row justify-content-start mb-xl-4">
                    @for (articulo of fila; track articulo) {
                      <div class="card mb-2 me-3 wrappedCardArticulosDetail">
                        <img [src]="articulo.imagen" alt="" style="width: 100%!important; height: 150px!important;">
                        <div class="card-body">
                          <p class="card-text mb-1">{{ articulo.fechaCreacion | date: "dd/MM/YYYY" }}
                          </p>
                          <p class="card-title">{{articulo.titulo}}</p>
                          <a href="#" [routerLink]="'/detalle/articulo/'+ transformarTitulo(articulo.titulo) +'/'+articulo.idNodo"
                          class="btn-link hvr-shrink">Ver más</a>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-3 order-1 order-xl-2">
            <div id="navbarFiltrosArticle" class="rounded p-3 mt-5">
              <form [formGroup]="articulosForm">
                <div class="mb-3">
                  <p class="titleSection">Categorías</p>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck1" (change)="checkedCategorias($event, 'Aliados Financieros')">
                    <label class="form-check-label" for="customCheck1">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          auto_graph
                        </span>
                        <p class="m-0">Aliados Financieros</p>
                      </div>
                    </label>
                  </div>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck2" (change)="checkedCategorias($event, 'Eventos')">
                    <label class="form-check-label" for="customCheck2">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          auto_graph
                        </span>
                        <p class="m-0">Eventos</p>
                      </div>
                    </label>
                  </div>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck3" (change)="checkedCategorias($event, 'Finanzas')">
                    <label class="form-check-label" for="customCheck3">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          auto_graph
                        </span>
                        <p class="m-0">Finanzas</p>
                      </div>
                    </label>
                  </div>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck4" (change)="checkedCategorias($event, 'Interés General')">
                    <label class="form-check-label" for="customCheck4">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          tips_and_updates
                        </span>
                        <p class="m-0">Interés General</p>
                      </div>
                    </label>
                  </div>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck5" (change)="checkedCategorias($event, 'Líneas de crédito')">
                    <label class="form-check-label" for="customCheck5">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          auto_graph
                        </span>
                        <p class="m-0">Líneas de crédito</p>
                      </div>
                    </label>
                  </div>
                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" id="customCheck6" (change)="checkedCategorias($event, 'Microcrédito')">
                    <label class="form-check-label" for="customCheck6">
                      <div class="d-flex flex-row align-items-center">
                        <span class="material-icons-outlined me-2">
                          auto_graph
                        </span>
                        <p class="m-0">Microcrédito</p>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <p class="titleSection">Autor</p>
                  @for (autor of listaAutores; track autor; let i = $index) {
                    <div class="form-check mb-2">
                      <input type="checkbox" class="form-check-input" id="authorCheck{{i}}" (change)="checkedAutores($event, autor.nombreUsuario)">
                      <label class="form-check-label" for="authorCheck{{i}}">
                        <p class="mt-1 mb-0">{{autor.nombreCompleto}}</p>
                      </label>
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <p class="titleSection">Tags</p>
                  @for (etiqueta of listaEtiquetas; track etiqueta; let i = $index) {
                    <div class="form-check mb-2">
                      <input type="checkbox" class="form-check-input" id="tagscheck{{i}}" (change)="checkedEtiquetas($event, etiqueta.nombre)">
                      <label class="form-check-label" for="tagscheck{{i}}">
                        <p class="mt-1 mb-0">{{etiqueta.nombre}}</p>
                      </label>
                    </div>
                  }
                </div>
                <button type="submit" class="btn btn-primary w-100" (click)="filtro()">Filtrar resultados</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<app-footer></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
